export const DELETE_CONFIG_MSG = "Output config is successfully deleted";
export const DELETE_BAND_MSG = "Deleted Band successfully";
export const DELETE_OUTPUT_MSG = "Deleted Output Element successfully";
export const STATUS = "Status";
export const CONFIGSAVE = "config-save";
export const VALID = "Valid";
export const INVALID = "Invalid";
export const BANDINGSAVE = "banding-save";
export const DELETE_ACTION_TYPE = "delete-output-config";
export const OUTPUT_CONFIG_MAP_HIGHLIGHT = "highlight-map";
export const OUTPUT_CONFIG_MAP_HIGHLIGHT_PARENT = "highlight-map-parent";
